<template>
  <template v-for="(item, index) of collectionSlice" :key="index">
    <slot :item="item" :index="index" />
  </template>
  <slot v-if="collectionLength === 0" name="if-empty" />
  <component :is="props.loaderContainer" ref="loaderContainerElement">
    <slot name="loader" />
  </component>
</template>
<script setup lang="ts" generic="T">
import { useVisibility } from '@utils/visibility';
import { computed, ref, watch, type Component } from 'vue';

defineOptions({
  name: 'VLazyDisplayable'
})

const emit = defineEmits<{
  exhausted: []
}>()

const props = withDefaults(
  defineProps<{
    collection: T[]
    size: number
    start?: number
    loaderContainer?: keyof HTMLElementTagNameMap | Component
  }>(),
  {
    loaderContainer: 'div',
    start: undefined
  }
)

defineSlots<{
  default(props: { item: T, index: number }): unknown
  'if-empty'(): unknown
  loader (): unknown
}>()

const collection = computed(() => props.collection)
const collectionSlice = computed(() => collection.value.slice(0, count.value))
const collectionLength = computed(() => collection.value.length)

const count = ref(props.start ?? props.size)

const loaderContainerElement = ref<HTMLElement>()

const isVisible = useVisibility(loaderContainerElement)
watch(isVisible, (visible) => {
  if (visible && count.value < collectionLength.value) count.value += props.size
})

watch(collectionLength, () => {
  if (isVisible.value) count.value += props.size
})

watch(
  count,
  (value) => {
    if (value >= collectionLength.value) emit('exhausted')
  },
  {
    immediate: true
  }
)
</script>